//Бизнес логика и данные самого приложения
import {backendPostRequest} from "@/domain/backend.api";
import i18n from "@/i18n";
import {downloadBase64File} from "@/domain/utils";

export default {
    namespaced: true,
    state: {
        userInfo:{},
        locations:[],
        userLocations:[],
        reports:[],
        fileList:[],

        tickets:[],
        messages:[],

        ticketsFilter:{
            date1: "",
            date2: "",
            locations: [],
            statuses:  []
        },

        reportsFilter: {
            date1: "",
            date2: "",
            reportLocations: [],
        },

        messagesFilter:{
            date1: "",
            date2: "",
            locations: [],
            statuses:  []
        },

        locationsFilter:[],
        ticketStatuses:[],
        messagesStatus:[],
        reportsTypes:[], //{id:1, name:''}
        reportsFiles:[], //{}
        currentTicketTab: 0,

        workStatus: {
            status: 0,
            description: '',
        },
    },

    mutations: {
        setReportsFiles(state, payload){
            state.reportsFiles = payload
        },

        setReportsTypes(state, payload){
            state.reportsTypes = payload
        },

        setWorkStatus(state, payload){
            state.workStatus = payload
        },

        setMessages(state, payload){
            state.messages = payload
        },

        setLocationsFilter(state, payload){
            state.locationsFilter = payload
        },
        setTicketStatuses(state, payload){
            state.ticketStatuses = payload
        },
        setMessagesStatus(state, payload){
            state.messagesStatus = payload
        },

        setTicketsFilter(state, payload){
            state.ticketsFilter = payload
        },

        setReportsFilter(state, payload){
            state.reportsFilter = payload
        },

        setMessagesFilter(state, payload){
            state.messagesFilter = payload
        },


        setTickets(state, payload){
            state.tickets = payload
        },

        setCurrentTicketTab(state, payload){
            console.log('setCurrentTicketTab', payload)
            state.currentTicketTab = payload
        },
        setFileList(state, payload){
            state.fileList = payload
        },

        setUserInfo(state, payload){
            state.userInfo = payload
        },
        setLocations(state, payload){
            state.locations = payload
        },
        setUserLocations(state, payload){
            state.userLocations = payload
        },

        setReports(state, payload){
            state.reports = payload
        },

    },
    actions: {

        async apiGetReportsFiles({commit}, payload){
            console.log('request', payload)
            const result = await backendPostRequest("api", {
                command: "getReportsFiles",
                payload: payload,
            })
            console.log('response', result)

            if (result.status==="ok"){
                commit("app/setReportsFiles", result.reports, {root: true})
            }else {
                commit("common/setToastMessage", { message: `${result.description}` },{root: true})
            }

        },

        async apiGetMetaInfo({commit}){
            const result = await backendPostRequest("api", {
                command: "getMetaInfo",
                payload: {},
            })

            if (result.status==="ok"){
                commit("app/setMessages", result.messages, {root: true})
                commit("setLocations",     result.locations)
                commit("setMessagesStatus",result.messageStatuses)
                commit("setTicketStatuses",result.ticketStatuses)
                commit("setReportsTypes", result.reports)
            }else {
                commit("common/setToastMessage", { message: `${result.description}` },{root: true})
            }
        },

        async apiGetMessages({commit}, payload){
            const result = await backendPostRequest("api", {
                command: "getMessages",
                payload: payload,
            })

            if (result.status==="ok"){
                commit("app/setMessages", result.messages, {root: true})
            }else {
                commit("common/setToastMessage", { message: `${result.description}` },{root: true})
            }
        },

        async apiSetMessageStatus({commit, dispatch, state}, payload){
            const result = await backendPostRequest("api", {
                command: "setMessageStatus",
                payload: payload,
            })

            if (result.status==="ok"){
                dispatch("apiGetMessages",{
                    date1: state.messagesFilter.date1,
                    date2: state.messagesFilter.date2,
                    locations: state.messagesFilter.locations,
                    statuses: state.messagesFilter.statuses
                })
            }else {
                commit("common/setToastMessage", { message: `${result.description}` },{root: true})
            }
        },

        async apiMessageRead({commit, dispatch, state}, payload){
            const result = await backendPostRequest("api", {
                command: "messageRead",
                payload: payload,
            })

            if (result.status==="ok"){
                dispatch("apiGetMessages",{
                    date1: state.messagesFilter.date1,
                    date2: state.messagesFilter.date2,
                    locations: state.messagesFilter.locations,
                    statuses: state.messagesFilter.statuses
                })
            }else {
                commit("common/setToastMessage", { message: `${result.description}` },{root: true})
            }
        },

        async apiNewTicket({commit, dispatch, state}, payload){
            commit("common/setIsLoading", true, {root: true})

            const result = await backendPostRequest("api", {
                command: "NewTicket",
                payload: payload,
            })


            console.log('>result', result)

            commit("common/setIsLoading", false, {root: true})

            if (result.status==="ok"){

                dispatch("apiGetTickets",{
                    date1: state.ticketsFilter.date1,
                    date2: state.ticketsFilter.date2,
                    locations: state.ticketsFilter.locations,
                    statuses: state.ticketsFilter.statuses
                })
            }else {
                commit("common/setToastMessage", { message: `${result.description}` },{root: true})
            }
        },

        async apiGetTickets({commit},payload){
            const result = await backendPostRequest("api", {
                command: "getTickets",
                payload: payload,
            })

            if (result.status==="ok"){
                console.log('apiGetTickets', result)
                commit("app/setTickets", result.tickets, {root: true})
                //запросим список тикетов
            }else {
                commit("common/setToastMessage", { message: `${result.description}` },{root: true})
            }


            console.log(commit)
            console.log(result)
        },

        async apiDeleteTicket({commit, dispatch, state}, payload){
            // console.log(commit, payload)

            commit("common/setIsLoading", true, {root: true})

            const result = await backendPostRequest("api", {
                command: "deleteTicket",
                payload: payload,
            })


            console.log('>result', result)

            commit("common/setIsLoading", false, {root: true})

            if (result.status==="ok"){
                console.log('result', result)
                dispatch("apiGetTickets",{
                    date1: state.ticketsFilter.date1,
                    date2: state.ticketsFilter.date2,
                    locations: state.ticketsFilter.locations,
                    statuses: state.ticketsFilter.statuses
                })
                //запросим список тикетов
            }else {
                commit("common/setToastMessage", { message: `${result.description}` },{root: true})
            }
        },

        async apiGetFileList({commit}){
            const result = await backendPostRequest("api", {
                command: "GetFileList",
                payload: {},
            })

            if (result.status==="ok"){
                commit("setFileList",result.files)
            }else {
                commit("common/setToastMessage", { message: `GetFileList error: ${result.description}` },{root: true})
            }

        },
        async apiGetFile({commit}, payload){
            const result = await backendPostRequest("api", {
                command: "GetFile",
                payload: payload,//GUID
            })

            if (result.status==="ok"){
                await downloadBase64File(result.base64, result.fileName)
            }else {
                commit("common/setToastMessage", { message: `apiGetFile error: ${result.description}` },{root: true})
            }

        },
        async apiPutFile({commit}, payload){
            const result = await backendPostRequest("api", {
                command: "PutFile",
                payload: payload,
            })

            if (result.status==="ok"){
                console.log(result)
                //commit("setFileList",result.files)
            }else {
                commit("common/setToastMessage", { message: `apiGetFile error: ${result.description}` },{root: true})
            }
        },


        async apiUserGetInfo({ commit }){
            const result = await backendPostRequest("api", {
                command: "UserGetInfo",
                payload: {},
            })
            //console.log(result)

            if (result.status==="ok"){
                console.log('result.UserInfo',result.UserInfo)
                commit("setUserInfo",result.UserInfo)

                commit("setUserLocations",result.Userlocations)
                commit("setReports",result.reports)
                console.log('setUserLocations', result.Userlocations)

                // commit("setMessagesStatus",result.messageStatuses)
                // commit("setTicketStatuses",result.ticketStatuses)

                let status = 0
                switch (result.UserInfo.workStatus){
                    case 'Новый':
                        status = 1
                        break
                    case 'УчредительныеДокументыПолучены':
                        status = 2;
                        break
                    case 'УчредительныеДокументыПроверены':
                        status = 2;
                        break
                    case 'ЗаключениеДоговора':
                        status = 3;
                        break
                    case 'ПолученСкан':
                        status = 4;
                        break
                    default:
                        status = 5;
                }
                commit("setWorkStatus", {status, description: result.UserInfo.workStatus})
                // console.log('locations',result.locations)
                // console.log('reports',result.reports)
                // console.log('messageStatuses',result.messageStatuses)
                // console.log('messageStatuses',result.ticketStatuses)



                let locations = []
                result.Userlocations.forEach(item=>{
                    locations.push(item)
                })
                commit("setLocationsFilter",locations)

            }else {
                console.log('execute error UserGetInfo')
            }

        },

        async apiUserUpdateInfo({commit},payload){
            const result = await backendPostRequest("api", {
                command: "UserUpdateInfo",
                payload: payload,
            })
            //console.log(result)
            if (result.status==="ok"){
                console.log('response UserUpdateInfo::')
                console.log(result)
                commit("setUserInfo", result.userInfo)
                commit("common/setToastMessage", { message: i18n.t("api.UserUpdateInfo_success") },{root: true})
            }else {
                commit("setUserInfo", result.UserInfo)
                commit("common/setToastMessage", { message: i18n.t("api.UserUpdateInfo_fail") },{root: true})
            }

        },

        async apiReportsUpdate({commit},payload){
            const result = await backendPostRequest("api", {
                command: "ReportsUpdate",
                payload: payload,
            })
            //console.log(result)
            if (result.status==="ok"){
                commit("setReports", result.reports)
                commit("common/setToastMessage", { message: i18n.t("api.ReportsUpdate_success") },{root: true})
            }else {
                console.log('request payload',payload)
                console.log('response:',result)
                commit("common/setToastMessage", { message: i18n.t("api.ReportsUpdate_fail") },{root: true})
            }

            //console.log(commit,payload)

        },
        // async apiLocationsGet({commit}){
        //     console.log(commit)
        //     const result = await backendPostRequest("users/executecommand", {
        //         command: "LocationsGet",
        //         payload: {},
        //     })
        //     console.log(result)
        //     if (result.status==="ok"){
        //         commit("setLocations", result.locations)
        //     }
        //
        // },

        // async apiExecutecommand({ dispatch, commit },payload){
        //     console.log(dispatch, commit)
        //     const result = await backendPostRequest("api", {
        //         command: payload.command,
        //         payload: payload.payload,
        //     })
        //
        //     console.log(result)
        //
        // },

    },
    getters: {
        getReportsFiles(state){
            let result = state.reportsFiles
            console.log('state.reportsFiles', result)
            // if (!result || result.length===0){ //TODO delete mock data
            //     result = [
            //       {date: '01.01.2023', locationId: "000000001", reportTypeId: 1, fileName: 'Аналитика 01.01.2023.xlsx', fileGUID: '123-123-123'},
            //       {date: '20.03.2023', locationId: "000000001", reportTypeId: 2, fileName: 'Отгрузки 20.03.2023.xlsx', fileGUID: '123-123-123'},
            //       {date: '30.03.2023', locationId: "000000001", reportTypeId: 3, fileName: 'Приемка 30.03.2023.xlsx', fileGUID: '123-123-123'},
            //     ]
            // }
            return result
        },

        getReportsFilesByTabs(state, getters){
            const reportTypeId = getters.getReportsTypes[state.currentTicketTab].id
            console.log('reportTypeId', reportTypeId)
            console.log('getters.getReportsFiles',getters.getReportsFiles)

            return getters.getReportsFiles.filter(item=>item.reportTypeId===reportTypeId)
        },

        getReportsTypes(state){
            let result = state.reportsTypes
            // if (!result){ //TODO delete mock data
            //     result = [{id: 1, name: 'Аналитика'}, {id: 2, name: 'Отгрузки'}, {id: 3, name: 'Приемка'} ]
            // }
            console.log('reportTypes', state.reportsTypes)
            return result
        },

        getWorkStatus(state){
            //TODO DEBUG FIX RETURN VALUE
            console.log(state)
            //return {status: 5, description: 'work'}
            return state.workStatus
        },

        getMessages(state){
            return state.messages
        },

        getLocationsFilter(state){
            return state.locationsFilter
        },
        getTicketStatuses(state){
            return state.ticketStatuses
        },
        getMessagesStatus(state){
            return state.messagesStatus
        },

        getTicketsFilter(state){
            return state.ticketsFilter
        },
        getReportsFilter(state){
            return state.reportsFilter
        },

        getMessagesFilter(state){
            return state.messagesFilter
        },


        getTickets(state){
            return state.tickets
        },

        getCurrentTicketTab(state){
            return state.currentTicketTab
        },

        getUserInfo(state){
            console.log('getUserInfo(state)',state.userInfo)
            return state.userInfo
        },
        getLocations(state){
            return state.locations
        },
        getUserLocations(state){
            return state.userLocations
        },

        getReports(state){

            return state.reports

        },
    }
}
